import { Typography } from 'src/components/atoms/typography';
import styled from 'styled-components';
import { Modal } from '@material-ui/core';
import { Paper } from 'src/components/atoms/paper';
import { Button } from 'src/components/atoms/button';

export const StyledModal = styled(Modal)`
  && {
  }
`;

export const ModalTitle = styled(Typography)`
  && {
    font-size: ${props => props.theme.typography.fontSize.h2};
    color: ${props => props.theme.palette.grayScale[80]};
    font-weight: bold;
    margin-bottom: 12px;
  }
`;

export const ModalContainer = styled(Paper)`
  && {
    width: 520px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;

export const Text = styled(Typography)`
  && {
    font-size: ${props => props.theme.typography.fontSize.large};
    color: ${props => props.theme.palette.primary.darker};
    font-weight: bold;
    margin-bottom: 12px;
    margin-top: 24px;
  }
`;

export const CloseButton = styled(Button)`
  && {
    margin-top: 24px;
    float: right;
  }
`;
